import React from 'react';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { ButtonVariants } from '../../Atoms/Button';

const GetStartedBanner: React.FC = () => {
  return (
    <div className="my-8 xl:my-24 lg:my-24 wg-container">
      <div className="rounded-xl flex justify-between shadow-lg px-12 sm:flex-col-reverse sm:px-4">
        <div className="sm:w-full flex flex-col justify-center">
          <h3 className="text-5xl font-bold text-brand-1000 sm:pt-8 sm:text-2xl leading-tight sm:text-s-28">
            Ready to get started?
          </h3>
          <div className="py-4 mt-5 w-2/5">
            <ButtonWithAnchor
              buttonText="Try for free"
              trackLabel="inpage_cta_productsforeveryone"
              buttonLink="https://cleartax.in/filing?utm_ref=itr_2025_organic_CT_homepage"
              target="_blank"
              buttonVariant={ButtonVariants.bluefilled}
              className="mr-4 sm:w-full sm:mb-6"
            />
          </div>
        </div>
        <div className="flex flex-row-reverse items-start w-1/2 sm:w-full sm:h-64 max-h-max">
          <img
            className="sm:object-scale-down sm:h-full"
            loading="lazy"
            src="https://assets1.cleartax-cdn.com/cleartax/images/1605855097_desktop_fold_readytogetstarted_rhs.png"
            alt="readysection"
          />
        </div>
      </div>
    </div>
  );
};

export default GetStartedBanner;
